module.exports = __webpack_public_path__ + "components/breakheader/static/icon--s5-aec72dcc4924cc918a41c883c992fbd2.svg";